// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"scroll-to-top_scrollToTop__FUtLT"};